// extracted by mini-css-extract-plugin
module.exports = {"globalTableHeader":"commonTable_globalTableHeader__22rF_","globalTableRow":"commonTable_globalTableRow__3UkWM","mainTable":"commonTable_mainTable__3ahrL"};